import {Module} from 'react-360-web';

export default class NativeFileReaderUtilitiesModule extends Module {
    constructor() {
        super('NativeFileReaderUtilitiesModule');
        this.ctx = null;
    }

    setContext(reactNativeContext) {
        this.ctx = reactNativeContext;
    }

    $convertBinaryStringToDataUrl(binStr, type, resolveId) {
        let byteArray = new Uint8Array(binStr.length);
        for (let i = 0; i < binStr.length; ++i) {
            let char = binStr.charCodeAt(i);
            // eslint-disable-next-line no-bitwise
            byteArray[i] = char & 0xff;
        }
        let blob = new Blob([byteArray], {type});
        let reader = new FileReader();
        let ctx = this.ctx;
        reader.onload = (event) => {
            ctx.invokeCallback(resolveId, [event.target.result]);
        };
        reader.readAsDataURL(blob);
    }
}
